// extracted by css-extract-rspack-plugin
export default {"favActive":"Report2Picker_favActive__Cq5uZ","description":"Report2Picker_description__MGsBT"};